
{
  "title": "Create a service listing",
  "description": "Add or update a provider listing within your subscription limits",
  "alerts": {
    "reviewRequired": "Your listing will be reviewed before it goes live in the directory."
  },
  "languageNote": "Note: All listings should be in English or Traditional Chinese for better visibility to Hong Kong users."
}
